import { Outlet } from "react-router";

export default function SiteLayout() {
  return (
    <Outlet />
  );
}